<div class="mb-4 mx-lg-4 mx-md-4 mx-sm-0">
    <!-- Card 1: Header + Totals -->
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body p-4">
            <ms-property-charge-schedule-summary-header
                [summary]="propertyChargeScheduleSummary()"
                [isLoading]="isLoading()">
            </ms-property-charge-schedule-summary-header>

            <ms-property-charge-schedule-summary-totals
                [summary]="propertyChargeScheduleSummary()"
                [isLoading]="isLoading()">
            </ms-property-charge-schedule-summary-totals>
        </div>
    </div>

    <ul class="nav nav-tabs summary-tabs">
        <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="activeTab() === 'invoices'"
                (click)="setActiveTab('invoices')">
                Invoices
            </button>
        </li>
        <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="activeTab() === 'auditLog'"
                (click)="setActiveTab('auditLog')">
                Audit Log
            </button>
        </li>
    </ul>

    <!-- Card 2: Tab Content -->
    @if (activeTab() === 'invoices' && propertyChargeScheduleId) {
        <div class="card border-0 shadow-sm mb-4 summary-tab-card">
            <div class="card-body p-4">
                <ms-property-charge-list
                    [propertyChargeScheduleId]="propertyChargeScheduleId"
                    [currentPropertyChargeListViewLocation]="PropertyChargeListViewLocations.PropertyChargeScheduleSummaryPage">
                </ms-property-charge-list>
            </div>
        </div>
    }
    @if (activeTab() === 'auditLog' && propertyChargeScheduleId) {
        <div class="card border-0 shadow-sm mb-4 summary-tab-card">
            <div class="card-body p-4">
                <ms-audit-logs
                    [entityId]="propertyChargeScheduleId"
                    [entityType]="AuditEntityType.PropertyChargeSchedule">
                </ms-audit-logs>
            </div>
        </div>
    }
</div>
